import * as React from 'react'
import './refundModal.scss'
import {connect} from "react-redux";
import {ActionType, reducerStoreType} from "../../reducers/types";
import {Dispatch} from "redux";
import FormControl from "@material-ui/core/FormControl";
import {MyInput, Label, PrimaryButton} from "../../components/CustomUIComp/CustomFormElem";
import {ChangeEvent} from "react";
import {injectIntl, IntlShape} from "react-intl";
import FormHelperText from "@material-ui/core/FormHelperText";


interface IProps {
    canRefundAmt: number,
    currency: string,
    orderNo: string,
    onClose: () => void,
    dispatch: Dispatch<ActionType<any>>,
    intl: IntlShape,
    origin: 'dashboard' | 'orders'
}

interface IState {
    refundAmt: string,
    amtError: string
}

class OrderRefundModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            refundAmt: '',
            amtError: ''
        }
    }

    onAmtChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            refundAmt: event.target.value
        })
    }
    refund = () => {
        // this.props.onClose()
        let {intl} = this.props
        let nRefundAmt = Number(this.state.refundAmt)
        if(isNaN(nRefundAmt)){
            this.setState({
                amtError: intl.formatMessage({id: 'amtShouldBeNum'})
            })
            return;
        }else if(nRefundAmt <= 0 ){
            this.setState({
                amtError: intl.formatMessage({id: 'amtGreaterThan0'})
            })
            return
        }else if(nRefundAmt > this.props.canRefundAmt){
            this.setState({
                amtError: intl.formatMessage({id: 'refundAmtLimit'}) + this.props.canRefundAmt
            })
            return
        }
        this.props.dispatch({
            type: 'REFUND',
            payload: {
                refundAmt: Number(this.state.refundAmt),
                orderNo: this.props.orderNo,
                origin: this.props.origin
            }
        })
    }
    refundAll = () => {
        this.setState({
            refundAmt: String(this.props.canRefundAmt)
        })
    }

    public render() {
        let {intl} = this.props
        return (<div className="refundModal">
                <div className="tips">
                    <label>{intl.formatMessage({id: 'canRefundAmt'})}({this.props.currency}):</label>
                    <span> {this.props.canRefundAmt}</span>
                </div>
                <div className="content">
                    <FormControl className="formControl" fullWidth error={this.state.amtError ? true : false}>
                        <span className="refundAll"
                              onClick={this.refundAll}>{intl.formatMessage({id: 'refundAll'})}</span>
                        <Label shrink htmlFor="refundAmt" fontSize={20}>
                            {intl.formatMessage({id: 'refundAmt'})}
                        </Label>
                        <MyInput id="refundAmt"
                                fontSize={18}
                                type="number"
                                name="refundAmt"
                                placeholder="0.00"
                                value={this.state.refundAmt}
                                onChange={this.onAmtChange}/>
                        {this.state.amtError ?
                            <FormHelperText id="component-error-text">{this.state.amtError}</FormHelperText> : null}
                    </FormControl>
                </div>
                <div className="buttonLine">
                    <PrimaryButton onClick={this.refund}>{intl.formatMessage({id: 'confirm'})}</PrimaryButton>
                </div>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        currency: state.orderDetail.currency,
        canRefundAmt: state.orderDetail.canRefundAmt,
        orderNo: state.orderDetail.orderNo
    }
})(OrderRefundModal))